function string_to_slug (str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaeeeeiiiioooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

$( document ).ready(function() {
  
  function galleryLoader(state) {
    const mainContent = document.querySelector('.main-content')
    const overlay = `<div class="gallery-overlay"><div><span class="fas fa-spinner fa-pulse"></span><p>Loading Gallery...</p></div></div>`
//     if(state) {
//       mainContent.insertAdjacentHTML('afterbegin', overlay)
//     } else {
//       document.querySelector('.gallery-overlay').remove()
//     }
  }
  
  
  
  function resetGrid() {
    const prevTemplate = `<div class='ndn-arrow-left'><span class="fa fa-chevron-left"></span></div>
	<div class='ndn-arrow-right'><span class="fa fa-chevron-right"></span></div>
	`
//     document.querySelector('.ndn-album').insertAdjacentHTML('afterbegin', prevTemplate)
    
 	const galleries = document.querySelectorAll('.ndn-album ul li');
   
    galleries.forEach((gallery, index) => {
      gallery.classList = 'album-image'
      const imageContent = gallery.querySelector('a').innerHTML
      gallery.innerHTML = imageContent
      if(index === 0) {
        gallery.classList.add('show')
      }
    });
    
    
    const arrowLeft = document.querySelector('.ndn-arrow-left')
    const arrowRight = document.querySelector('.ndn-arrow-right')
    if(arrowLeft) {
      arrowLeft.addEventListener('click', function(e) {
        const activeGallery = document.querySelector('.show')
        const prevSibling = activeGallery.previousElementSibling
        if (prevSibling) {
        	 activeGallery.classList.remove('show')
             prevSibling.classList.add('show')
        }
      })
    }
    if(arrowRight){
      arrowRight.addEventListener('click', function(e) {
        const activeGallery = document.querySelector('.show')
        const nextSibling = activeGallery.nextElementSibling
        if (nextSibling) {
        	 activeGallery.classList.remove('show')
             nextSibling.classList.add('show')
        }
      })
    }
    galleryLoader(false)
  }
  
  async function triggerLoadMore() {
    var loadMore = document.querySelector('.load-more')
    if (loadMore) {
      if(loadMore.style.display !== 'none') {
        loadMore.click()
      }
      else {
      	clearInterval(galleryInterval)
      }
    } 
  }
  
  async function galleryInit() {
    galleryInterval = setInterval(triggerLoadMore, 1000)
    await setTimeout(resetGrid, 5000)
  }
  
  
  // NDN gallery settings
  if (window.location.href.includes('gallery')) {
    galleryLoader(true)
    galleryInit()
  }
  
  // Format pagination
  var paginations = document.querySelectorAll('.pagination ul li');
  if(paginations.length) {
    
      var paginationTemplate = document.querySelector('.pagination ul')
      paginationTemplate.innerHTML = '';
      var pages = Array.from(paginations)
	  var lastPage = pages.slice(-1)[0];
      var firstPage = pages[0];
      var current = 0;
      var last = 0;
      pages.forEach(function(page, index) {
        if(page.className.includes('current')) {
       	 current = index;
        }
      });
    if (pages.length > 5) {
      if(current + 3 >= pages.length) {
       	last = pages.length; 
      } else {
        last = current + 3 
      }
     // cut the list
      pages.slice(current,last).forEach(function(el) {
        paginationTemplate.appendChild(el);
      });
      if((last !== pages.length) && (parseInt(lastPage.querySelector('a').textContent) - 1
         !== parseInt(Array.from(document.querySelectorAll('.pagination ul li')).slice(-1)[0].textContent))) {
        paginationTemplate.appendChild(document.createTextNode("..."));
      }
      if(last !== pages.length) {
        paginationTemplate.appendChild(lastPage);
      }
      
      paginationTemplate.insertBefore(firstPage, document.querySelector('.pagination ul').childNodes[0]);
      if(parseInt(Array.from(document.querySelectorAll('.pagination ul li')).slice(1,2)[0].textContent)
        !== parseInt(firstPage.querySelector('a').textContent) + 1
      ) {
        paginationTemplate.insertBefore(document.createTextNode("..."), document.querySelector('.pagination ul').childNodes[1]);
      }
    } else {
      pages.forEach(page => paginationTemplate.appendChild(page))
    }
  }
 
  
  if(window.location.href.includes('find-a-wholesale-distributor')) {
    setTimeout(() => $("#search_filter_13527").click(), 1500);    
    setTimeout(sortLocations, 2500);
  }
  
  function sortLocations() {
   var addresses = document.querySelectorAll('.addresses ul li');
   var addressTemplate = document.querySelector('.addresses ul');
   addressTemplate.innerHTML = ''
    Array.from(addresses).sort(function(a,b) {
      // sort nodeList
      a = a.querySelector('.name').textContent.trim()
      b = b.querySelector('.name').textContent.trim()
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }).forEach(function(el) {
      addressTemplate.appendChild(el);
    });
  }

  
  if(window.location.href.includes('retailers-page')) {
    $("#search_filter_13528").click();
    setTimeout(sortLocations, 1500);
  }
  
  $('#search_filter_13527').on('click', function(e) {
    if(e.target.checked) {
         $('#search_filter_13528:checked').click()
      }
    setTimeout(sortLocations, 1500);
  	});
  
  $('#search_filter_13528').on('click', function(e) {
    if(e.target.checked) {
        $('#search_filter_13527:checked').click()
      }
    setTimeout(sortLocations, 1500);
  });
  
  

  
  var majorCollections = ['frit', 'rods', 'noodles', 'stringers']
  
  var collectionSlug = window.location.pathname.split('/').slice(-1)[0]
  if(window.location.href.includes('collections') && collectionSlug) {
   	 $("h4:contains('Family-Specialty')").parent().hide()
  }
  
  
  // Hubspot Settings
  var portalId = "3066318";
  var formId = "6305dc1d-a655-48f4-90b9-d86010dca0a4";
  
  // Locate Product
  $('#locateProduct').on('click', function(e){
  	window.location.href = '/pages/how-to-purchase'
  });
  
  // Start a new search product page
  $('#startSearch').on('click', function(e) {
    var categories = ['frit', 'rods', 'stringers', 'noodles', 'sheet']
    
    
    // check if link is under collection
    if(window.location.href.includes('collections')) {
       // remove 
       window.location.href = window.location.href.split('products')[0]
    } else if(window.location.href.includes('products')) {
       var description = document.querySelector('.ec-description-container p').textContent.toLowerCase()
       categories.forEach(category => {
         if(description.includes(category)) {
           if(category == 'sheet') {
			category = 'sheet glass';
           }
           window.location.href = `${window.location.origin}/collections/${string_to_slug(category)}`
         }
	    });
    } else {
      window.location.href = `${window.location.origin}/collections`
    }
      
    // redirect to collection url
  });


    // Start a new search product page
  $('#startSearch2').on('click', function(e) {
  var colurls = $(this).attr('colurl');
    
    // check if link is under collection
    if(colurls) {
       // remove 
       window.location.href = colurls;
    } else {
      window.location.href = `${window.location.origin}/collections`
    }
      
    // redirect to collection url
  });


  
  
  
  $('#newsletterForm :submit').on('click', function(e) {
    // Process newsletter form submission
    e.preventDefault();
    var inputs = $('#newsletterForm :input.form-control');
    
    var payload = {
      fields: [
        {
          name: 'email',
          value: Array.from(inputs).find(input => input.name == 'email').value
        },
        {
          name: 'firstname',
          value: Array.from(inputs).find(input => input.name == 'firstname').value
        },
        {
          name: 'lastname',
          value: Array.from(inputs).find(input => input.name == 'lastname').value
        }
      ]
    }
    $.post({
      url: `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
      type: "POST",
	  data: JSON.stringify(payload),
      success: function(response) {
        toastr.options = {
          "closeButton": true,
          "debug": false,
          "newestOnTop": false,
          "progressBar": false,
          "positionClass": "toast-top-center",
          "preventDuplicates": false,
          "onclick": null,
          "showDuration": "800",
          "hideDuration": "1000",
          "timeOut": "5000",
          "extendedTimeOut": "1000",
          "showEasing": "swing",
          "hideEasing": "linear",
          "showMethod": "fadeIn",
          "hideMethod": "fadeOut"
        }
        toastr.info(response.inlineMessage);
        $('#newsletterForm')[0].reset();
        $("#newsletter .close").click();
      },
	  contentType: 'application/json'
    })
	
  });
  
	//   	Attach modal behaviour on `Stay Current` links
  Array.from($('a:contains("Stay Current")')).forEach( function(item) {
    var current = $(item);
	current.attr('data-toggle', 'modal');
    current.attr('data-target', '#newsletter');
  });
  
  $('.dropdown-toggle span').on('click', function(e) {
		window.location.href = $(this).parents('.dropdown-toggle').attr('href')
    });
  $('.dropdown-menu a.dropdown-toggle:after').on('click', function(e) {
	  if (!$(this).next().hasClass('show')) {
		$(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
	  }
	  var $subMenu = $(this).next(".dropdown-menu");
	  $subMenu.toggleClass('show');

	  $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
		$('.dropdown-submenu .show').removeClass("show");
	  });

	  return false;
	});
  
  $('.header__search-toggle').on('click', function() {
   		$(this).hide();
    	$('.site-header__search').show();
  });
  
  if(window.location.href.includes('frit')) {
	//    Frit collection specific styles 
	var gridItems = document.querySelectorAll('#Collection .grid--view-items .grid__item')
    gridItems.forEach(item => {
      item.classList.remove('small--one-half');
      item.classList.add('small--one-fifth');
    })
  }
  
  // generate breadcrumbs
  var breadcrumbs = document.querySelector('.breadcrumbs-link')
  if(breadcrumbs) {
    var breadcrumbLink = (link, text) => {
      return `
		<li class="list-inline-item"><a href="${link}">${text}</a></li>
		`
    }
    var linkTemplate = breadcrumbLink('/', 'Home');

    var currentLink = document.querySelector('.navbar').querySelector(`a[href="${window.location.pathname}"]`)
    var closestParent = currentLink.closest('.dropdown')
    if (closestParent) {
      var parentLink = currentLink.closest('.dropdown').querySelector('.dropdown-toggle')
      var parentText = parentLink.text
      var parentHref = parentLink.getAttribute('href')
      if(parentLink) {
        linkTemplate += breadcrumbLink(parentHref, parentText)
      }
    }
   
    linkTemplate += breadcrumbLink(currentLink.getAttribute('href'), currentLink.text)
    breadcrumbs.innerHTML = linkTemplate
  }
  
  
  if(window.location.href.includes('contact-us')) {
    
  	// Implement contact us tabs
	var members = $('.team-members > div')
	// Get all available category
	var categories = Array.from(members).map(member => member.dataset.category)
	var distinctCategories = [...new Set(categories)]
	var teamCategories = document.querySelector('.team-categories')

	function getCategories() {
		var template = '<li class="list-inline-item link-category">All</li>'
		distinctCategories.forEach(category => {
			var content = category
			// modify text
			if(category.includes('-')) {
				content = category.split('-').join(' ')
			}
			if(content.length < 3) {
				content = content.toUpperCase()
			}
			template += `<li class="list-inline-item link-category">${content}</li>`
		})
		var outerTemplate = `
			<ul class="list-unstyled list-inline list-categories">
			${template}
			</ul>`

		return outerTemplate
	}

  if(teamCategories) {
	teamCategories.innerHTML = getCategories()
  }


	// Add grid behaviour
	function styleActiveMembers() {
		var teamMembers = document.querySelector('.team-members')
		if(activeMembers.length === 1) {
			teamMembers.style.gridTemplateColumns = "30%"
		}
		else if(activeMembers.length === 2) {
			teamMembers.style.gridTemplateColumns = "30% 30%"
		}
		else if(activeMembers.length === 3) {
			teamMembers.style.gridTemplateColumns = "30% 30% 30%"
		} else {
			teamMembers.removeAttribute('style')
			teamMembers.style.gridTemplateColumns = ""
		}
	}

	function hideAllMembers() {
		Array.from(members).forEach(member => {
			member.classList.add('hide')
		})
	}
	function showAllMembers() {
		Array.from(members).forEach(member => {
			member.classList.remove('hide')
		})
	}
	var activeMembers = ''
	function showActiveLink(link) {
		if(link === 'all') {
			showAllMembers()
			activeMembers = members
			// styleActiveMembers()
			return
		}
		activeMembers = Array.from(members).filter(member => member.dataset.category === link)
		// styleActiveMembers()
		hideAllMembers()
		activeMembers.forEach(member => {
			member.classList.remove('hide')
		})
	}

	function addLinkBehavior() {
		var linkCategories = document.querySelectorAll('.link-category')
		linkCategories.forEach(link => {
			
			link.addEventListener('click', (e) => {
				Array.from(linkCategories).forEach(link => {
					link.classList.remove('active')
				})
				// Add what to do if user clicks the link
				var category = e.target.innerHTML.toLowerCase()
				e.target.classList.add('active')
				if(category.includes(' ')) {
					category = category.split(' ').join('-')
				}
				showActiveLink(category)
			})
			if(link.innerText==='All') {
				link.click()
			}
		})
	}

	addLinkBehavior()

	styleActiveMembers()
    
    
	}


//	// Implement FAQ page tabs
  if(window.location.href.includes('faq')) {
	var faqTabs = document.querySelectorAll('.faq-tab')
	var faqContents = document.querySelectorAll('.content-tabs > div')
    var collapses = document.querySelectorAll('.content-tabs .collapse')
	var collapsButtons = document.querySelectorAll('.accordion .card .btn-link')

	// initially close accordions
	function initialize() {
		collapsButtons.forEach(function(button) {
         	button.textContent = button.textContent.trim()
            console.log(button.text)
			button.classList.remove('collapsed')
			button.classList.add('collapsed')
		})
		collapses.forEach(function(collapse) {
			collapse.classList.remove('show');
		})
	}

	function clearActiveTabs(element) {
		element.classList.remove('active')
	}
	function clearActiveContents(element) {
		element.classList.remove('show')
		element.classList.add('hide')
	}
	function showAllContents(element) {
		element.classList.remove('hide')
	}
	function showActiveContent(element) {
		// show all if element can't be found
		if (!element) {
			faqContents.forEach(showAllContents)
			return
		}
		element.classList.remove('hide')
		element.classList.add('show')
	}
	function clearTabs() {
		faqTabs.forEach(clearActiveTabs)
		faqContents.forEach(clearActiveContents)
	}
  
	initialize()
	
	faqTabs.forEach(function(tab) {
		tab.addEventListener('click', function(e) {
			clearTabs()
			e.target.classList.add('active')
			var activeTab = e.target.dataset.tab
			showActiveContent(document.querySelector('.'+ activeTab))
		})
	})   
  }
});



// JS scripts for project ideas slider
if(window.location.href.includes('project-ideas')) {
  document.getElementById("leftArrow").setAttribute("style", "border-bottom: 0; font-size: 1.3rem");
  document.getElementById("rightArrow").setAttribute("style", "border-bottom: 0; font-size: 1.3rem");
  
  var itemImg = document.querySelectorAll(".slider-item-img");
  var paginationNum = document.querySelectorAll(".number");
  
  var n;
  
  for (n = 0; n < itemImg.length; n++) {
    itemImg[n].style.height = "320px";
    itemImg[n].style.objectFit = "contain";
  }
  
  for (n = 0; n < paginationNum.length; n++) {
    paginationNum[n].style.display = "block";
  }
  
  var slide_index = 1;
  displaySlides(slide_index);
  
  function nextSlide(flag) {
    // move active slide to the next item
    var allSlides = document.querySelectorAll('.number-pagination .number-item');

//     var activeGalleries = document.querySelectorAll('.number-item[style*="display: block"]');
    var activeSlide = document.querySelector('.number-pagination .item-active');
    // return if active slide is the last item on allSlides
    if(flag === 'next' && activeSlide.dataset.id == allSlides[allSlides.length -1].dataset.id) {
      return
    } else if (flag !== 'next' && activeSlide.dataset.id == allSlides[0].dataset.id) {
      return
    }
    var allIds = Array.from(allSlides).map(slide => slide.dataset.id);
    
    if(flag === 'next') {
	  var nextSlideId = Number(activeSlide.dataset.id) + 1;
    } else {
      var nextSlideId = Number(activeSlide.dataset.id) - 1;
    }
    
//     var activeIds = Array.from(activeGalleries).map(gallery => {
//     	return gallery.dataset.id;
//     });
    
    if(nextSlideId < allIds[0]) {
    	nextSlideId = allIds.slice(-1)[0];
    } else if (nextSlideId > allIds.slice(-1)[0]) {
    	nextSlideId = allIds[0];
    }
    
    if(flag === 'next') {
    	triggerPagination(nextSlideId, 'next')
    } else {
      	triggerPagination(nextSlideId, 'prev')
    }
    setActiveItem(nextSlideId);
  }
  
  function triggerPagination(id, flag) {
    // check if next active item belongs to the nxt pagination set
    var activeNumberItems = document.querySelectorAll('.number-item[style*="display: block"]')
    var lastNumberItem = activeNumberItems[activeNumberItems.length - 1];
    
    if(flag == 'next') {
      if(Number(id) > Number(lastNumberItem.dataset.id)) {
        // check if there is succeeding item on pagination
        var nextItem = document.querySelector(`.number-pagination .gallery-${id}`).nextElementSibling
          // trigger next pagination 
        if(nextItem) {
            nextPaginationItems('next')
        }
      }
    } else {
     if(Number(id) < Number(activeNumberItems[0].dataset.id)) {
        // check if there is succeeding item on pagination
        var nextItem = document.querySelector(`.number-pagination .gallery-${id}`).previousElementSibling
          // trigger next pagination item
        if(nextItem) {
            nextPaginationItems()
        }
      }
    }
   	
  }
  
  // ======================================================================================
  
  function pageSlider(querySet, page, items) {
    
    var trimStart = (page - 1) * items;
    var trimEnd = trimStart + items;

    var trimmedData = querySet.slice(trimStart, trimEnd);

    return {
      'querySet': trimmedData
    }
  }
  
  var activeItems = document.querySelectorAll('.number-pagination .number-item');
  var array = Array.from(activeItems);
  
  var state = {
    'querySet': array,
    'page': 1,
    'items': 6,
  }
  
  function handleButtonVisibility() {
  	// check if pwede mag next or prev
    // count pila ang active numbers, if less than ten disable ang next button
    // update kay naglahi na ang numbering sa pagination
    var activeNumbers = document.querySelectorAll('.number-item[style*="display: block"]')
    if(activeNumbers.length < 6) {
    	// hide the next button
      document.querySelector('.thumbnail-right-arrow').style.display = 'none'
    } else {
      document.querySelector('.thumbnail-right-arrow').style.display = 'block'
    }
    if(activeNumbers[0] && activeNumbers[0].dataset.id == 1) {
      document.querySelector('.thumbnail-left-arrow').style.display = 'none'
    } else {
      document.querySelector('.thumbnail-left-arrow').style.display = 'block'
    }

  }
  
  function nextPaginationItems(flag) {
    // var activeData = document.querySelectorAll('.number-item[style*="display: block"]').length;
    
    if (flag === 'next') {
      state.page++;
    } else {
      state.page--;
    }
    
    // if state.page is 0, increment once to remain in page 1
    if (state.page == 0) {
      state.page++;
    }
    
    var page = state.page;
    var data = pageSlider(state.querySet, page, state.items);
      
    var pageItems = data.querySet;
    
    array.forEach((item) => {
      if (!pageItems.includes(item)) {
        item.style.display = "none";
      } else {
        item.style.display = "block";
      }
    });
    
    handleButtonVisibility()

  }
  
  // ======================================================================================
  
  function currentSlide(n) {
    displaySlides(slide_index = n);
  }
  
  function displaySlides(n) {
    var i;
    
    var slides = document.getElementsByClassName("slider-item");
    var number = document.getElementsByClassName("number");
	
    if (n > slides.length) { slide_index = 1; }
    if (n < 1) { slide_index = slides.length; }

    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }

    slides[slide_index-1].style.display = "block";
  }
  
  // ======================================================================================
  
  var innerDiv = document.createElement('div');
  innerDiv.className = 'inner-div-slider';
  var sliderItems = document.querySelectorAll(".slider-item");
  var sliderItemsCopy = Array.from(sliderItems).map(slider => slider)
  var numberItems = document.getElementsByClassName("number-item");
  var numberItemsCopy = Array.from(numberItems).map(item => item)
  var collectionSliderItem = document.getElementById("sliderItemCollection");
  var collectionNumberItem = document.getElementById("numberPagination");
  
  var paginationInnerDiv = document.createElement('div');
  paginationInnerDiv.className = 'inner-div-pagination';
  
  function resetPaginationNumbers() {
  	// Call after filter change, regenerate the pagination items via existing slider-item
    var paginationNumbers = document.querySelectorAll('.number-pagination .number-item')
    Array.from(paginationNumbers).forEach((pagination, index) => {
      pagination.querySelector('.number').textContent = index + 1
    })
  }
  
  function filteredImages(category) {
    if (category !== 'all') {
      
      if (sliderItems.length == sliderItemsCopy.length && numberItems.length == numberItemsCopy.length) {
        
        Array.from(sliderItems).forEach((item) => {
          if (item.dataset.category.toLowerCase() === category) {
            innerDiv.appendChild(item);
          } else {
            collectionSliderItem.removeChild(item);
          }
        });
        
        collectionSliderItem.appendChild(innerDiv);
        
        [...sliderItems].forEach((item, index) => {
          if (index == 0 || item == innerDiv.firstElementChild) {
            item.style.display = "block";
          } else {
            item.style.display = "none";
          }
        });
        
        [...numberItems].forEach((item) => {
          if (item.dataset.category.toLowerCase() !== category) {
            collectionNumberItem.removeChild(item);
          }
          item.style.display = "block";
        });
        
        var filteredNumberItems = document.querySelectorAll(".number-item");
        
        filteredNumberItems.forEach((item, index) => {
          if (index == 0) {
            item.classList.add('item-active');
            item.style.opacity = '1';
          } else {
            item.classList.remove('item-active');
            item.style.opacity = '0.6';
          }
        });
      } else {
        
        var i;
        var innerDivSlider = document.querySelector(".inner-div-slider");
        var sliderItemList = [...sliderItems]
        
        for (i = 0; i < sliderItemList.length; i++) {
          sliderItemList[i].remove();
          sliderItemList.splice(i);
        }
        
        [...sliderItemsCopy].forEach((item) => {
          sliderItemList.push(item);
        });
        
        if (innerDivSlider.hasChildNodes()) {
          innerDivSlider.innerHTML = "";
        }
        
        [...sliderItemList].forEach((item, index) => {
          if (item.dataset.category.toLowerCase() === category) {
            innerDivSlider.appendChild(item);
            return;
          }
          
          if (index == 0) {
            item.style.display = "block";
          } else {
            item.style.display = "none";
          }
        });
        
        innerDivSlider.firstElementChild.style.display = "block";
        collectionSliderItem.appendChild(innerDivSlider);
        var filteredSliderItems = document.querySelectorAll(".slider-item");
        
        [...filteredSliderItems].forEach((item, index) => {
          if (index == 0) {
            item.style.display = "block";
          } else {
            item.style.display = "none";
          }
        });
        
        var numberItemList = [...numberItems];
        var paginationCollection = document.getElementById("numberPagination");
        
        for (i = 0; i < numberItemList.length; i++) {
          numberItemList[i].remove();
          numberItemList.splice(i);
        }
        
        [...numberItemsCopy].forEach((item) => {
          numberItemList.push(item);
        });
        
        if (paginationCollection.hasChildNodes()) {
          paginationCollection.innerHTML = "";
        }
        
        numberItemList.forEach((item) => {
          if (item.dataset.category.toLowerCase() === category) {
            paginationCollection.appendChild(item);
            return;
          }
        });
        
        var filteredNumberItems = document.getElementsByClassName("number-item");
        
        [...filteredNumberItems].forEach((item, index) => {
          if (index == 0) {
            item.style.opacity = '1';
            item.classList.add('item-active');
          } else {
            item.style.opacity = '0.6';
            item.classList.remove('item-active');
          }
        });
        
      }
    } else {
      collectionSliderItem.innerHTML = '';
      
      [...sliderItemsCopy].forEach((item) => {
        collectionSliderItem.appendChild(item);
        
        if (item == collectionSliderItem.firstElementChild) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
      
      collectionNumberItem.innerHTML = '';
      [...numberItemsCopy].forEach((item, index) => {
        collectionNumberItem.appendChild(item);
        
        if (index == 0) {
          item.style.opacity = '1';
          item.classList.add('item-active');
        } else {
          item.style.opacity = '0.6';
          item.classList.remove('item-active');
        }
        
        if (index < 6) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
      
    }
    resetPaginationNumbers();
    handleButtonVisibility();
    
  }
  
  var category = document.querySelectorAll(".list-inline-item.project-ideas");
  category.forEach((item) => {
    item.addEventListener('click', (e) => {
      var current = document.querySelectorAll(".project-ideas.active");
      current[0].className = current[0].className.replace(" active", "");
      item.className += " active";
      filteredImages(item.dataset.name);
    })
  });
  
  // ======================================================================================

  
  var collectionItems = document.querySelectorAll('.number-pagination .number-item');
  var itemArray = Array.from(collectionItems);

  function numberSlider(querySet, page, items) {
    var trimStart = (page - 1) * items;
    var trimEnd = trimStart + items;

    var trimmedData = querySet.slice(trimStart, trimEnd);

    var pages = Math.ceil(querySet.length / items);

    return {
      'querySet': trimmedData,
      'pages': pages,
    }
  }
  
  var state = {
    'querySet': itemArray,
    'page': 1,
    'items': 6,
  }

  renderAll();

  function renderAll() {
    var data = numberSlider(state.querySet, state.page, state.items);

    var pageItems = data.querySet;

    itemArray.forEach((item) => {
      if (!pageItems.includes(item)) {
        item.style.display = "none";
      } else {
        item.style.display = "block";
      }
    });
  }
  
  // ======================================================================================
  
  var firstSlide = Array.from(collectionItems).map(slide => slide.dataset.id)[0];
  setActiveItem(firstSlide);
  
  var numberItemColumn = document.querySelectorAll('.number-pagination .number-item');
  
  numberItemColumn.forEach(item => {
    item.addEventListener('click', (e) => {
      setActiveItem(item.dataset.id);
    })
  })
  
  function resetGallery() {
  	var slides = document.querySelectorAll('.slider-item');
    var paginations = document.querySelectorAll('.number-pagination .number-item');
    
    slides.forEach(slide => {
      slide.style.display = 'none';
      slide.classList.remove('item-active');
    })
    paginations.forEach(pagination => {
      pagination.style.opacity = '0.6';
      pagination.style.textAlign = 'center';
      pagination.classList.remove('item-active');
    })
  }
  
  function setActiveItem(id) {
    // Set active number item in number pagination through the use of forloop.index
    var slides = document.querySelectorAll(`.gallery-${id}`);
    resetGallery();
    
    slides.forEach(slide => {
      slide.style.display = 'block';
      slide.style.opacity = '1';
      slide.classList.add('item-active');
    })
    

  }
  setActiveItem(1);
  
  var btn = document.querySelectorAll(".download-btn-pdf");
  btn.forEach((item) => {
    item.addEventListener('click', (e) => {
      downloadPDF(item.dataset.link);
    })
  });
  
  function downloadPDF(link) {
    window.open(link);
  }
  
  handleButtonVisibility();
}

var url = ['stringers', 'noodles', 'rods', 'frit']

if(window.location.href.includes('sheet-glass')) {
  
  var a = document.querySelector(".product-list-sg");
  a.addEventListener('click', (e) => {
    window.open(a.dataset.link);
  });
  
} else {
  
  url.map((item) => {
    
    if(window.location.href.includes(item)) {
      var n = document.querySelector(".product-list");
      n.addEventListener('click', (e) => {
        window.open(n.dataset.link);
      });
    }
    
  });
}

// if(window.location.href.includes('find-a-wholesale-distributor')) {
  
//   function storeLocator () {
//     $.get('https://oceansidecompatible.com/apps/store-locator', function(response, status) {
//       var parser = new DOMParser();
//       var htmlDoc = parser.parseFromString(response, 'text/html');
//       var locator = $(htmlDoc).find('#col-main')[0];
      
//       // $(htmlDoc).find('#store_map')[0].remove()
//       // var mapScript = locator.childNodes[15];
//       // var scriptAdded = $("head").append(mapScript);
      
//       // var dataScripts = [
//       //   '<script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/42/4/common.js"></script>',
//       //   '<script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/42/4/util.js"></script>',
//       //   '<script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/42/4/geocoder.js"></script>',
//       //   '<script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/42/4/map.js"></script>',
//       //   '<script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/42/4/geometry.js"></script>',
//       //   '<script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/42/4/directions.js"></script>',
//       //   '<script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/42/4/marker.js"></script>',
//       //   '<script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/42/4/onion.js"></script>',
//       //   '<script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/42/4/infowindow.js"></script>',
//       //   '<script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/42/4/controls.js"></script>'
//       // ];
      
//       // dataScripts.forEach((item) => {
//       //   $("head").append(item);
//       // });

//       $('.all').append(locator);

//       var title = $('#store-locator-title');

//       title.addClass("my-4 text-center");
//       title[0].innerHTML = "Find a Wholesale Distributor";

//     });
//   }
  
//   storeLocator();
  
// }